import React from 'react'
import { IProps } from './index'
import { Text } from 'marketing-site/src/library/elements/Text'
import { Image } from 'marketing-site/src/library/elements/Image'
import { mq } from 'marketing-site/src/library/utils'

export function EditorialListWithImage({ heading, listItems, image }: IProps) {
  return (
    <section className="editorial-lwi">
      <div className="editorial-lwi__text">
        <p>
          <Text brand="default" size="body">
            {heading}
          </Text>
        </p>
        <ul className="editorial-lwi__list">
          {listItems.map((item, index) => {
            return (
              <li className="editorial-lwi__list-item" key={index}>
                <div className="editorial-lwi__list-item-icon">
                  <Image url={item.icon} />
                </div>
                <div className="editorial-lwi__list-item-copy">
                  <div>
                    <Text brand="default" size="body-bold">
                      {item.title}
                    </Text>
                  </div>
                  <p>
                    <Text brand="default" size="body">
                      {item.description}
                    </Text>
                  </p>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
      <div className="editorial-lwi__image">
        <Image {...image} />
      </div>

      <style jsx>{`
        .editorial-lwi {
          display: grid;
          grid-template-areas:
            'image'
            'text';
          grid-gap: 20px;
          margin: 40px 0;
          background-image: none;
        }

        .editorial-lwi__text {
          grid-area: text;
          align-self: center;

          > p {
            padding-bottom: 30px;
          }
        }
        .editorial-lwi__image {
          grid-area: image;
        }

        .editorial-lwi__list-item {
          display: flex;
          padding-bottom: 20px;
        }
        .editorial-lwi__list-item-icon {
          flex-grow: 0;
          flex-shrink: 0;
          flex-basis: 50px;
          padding-right: 10px;
        }

        .editorial-lwi__list-item-copy {
          > * {
            padding-bottom: 10px;
          }
        }

        @media (${mq.tablet}) {
          .editorial-lwi {
            grid-template-areas:
              'text image'
              'text image';
            grid-template-columns: repeat(2, 1fr);
            padding: 100px 40px 100px 60px;
            margin: -20px -40px -20px -60px;
          }
        }
      `}</style>
    </section>
  )
}
